import React from 'react'

import "./styles.scss"
import Input from '../../../Input/Input'
import Button from '../../../Button'

export default function SelectField({
    data,
    setData,
    indexField,
    indexOption,
    totalSize
}) {
    const setValue = (key, value) => {
        setData(data => {
            // data.fields[indexField].options = []
            // data.fields[indexField].options[indexOption][key] = value
            data.fields[indexField].options[indexOption] = {
                ...data.fields[indexField].options[indexOption],
                [key]: value
            }

            return { ...data }
        })
    }

    const remove = () => {
        setData(data => {
            data.fields[indexField].options.splice(indexOption, 1)

            return { ...data }
        })
    }

    return (
        <div className="select-field">
            <div style={{ flex: 1 }}>
                <Input
                    name="name"
                    label="Nome"
                    placeholder="Nome da opção"
                    value={data.fields[indexField]?.options[indexOption]?.name}
                    onChange={e => setValue("name", e.target.value)}
                    waitTime={50}
                />
            </div>
            <div style={{ flex: 1 }}>
                <Input
                    name="value"
                    label="Valor"
                    placeholder="Valor do campo"
                    value={data.fields[indexField]?.options[indexOption]?.value}
                    onChange={e => setValue("value", e.target.value)}
                    waitTime={50}
                />
            </div>
            {totalSize > 1 &&
                <div>
                    <Button
                        variant={"delete"}
                        icon="trash"
                        onClick={remove}
                        size="short"
                    />
                </div>
            }
        </div>
    )
}